<template>
  <div id="reportes-page" class="container-fluid">
    <div id="formulario-top" class="container">
      <div class="row">
        <div id="desde" class="col-sm-2 col-sm-offset-1">
          <date-picker :date="date" :option="option2" @change="validate($event, 'desde')"></date-picker>
          <span style="color: red; font-size: 10px">{{desdeText}}</span>
        </div>
        <div id="hasta" class="col-sm-2 col-sm-offset-1">
          <date-picker :date="date" :option="option" @change="validate($event, 'hasta')"></date-picker>
          <span style="color: red; font-size: 10px">{{hastaText}}</span>
        </div>
        <div class="col-sm-2 col-sm-offset-1">
          <select-c name="desde" id="ducto" placeholder="DUCTO" :options="ductos" @changeSelect="changeSelected()"></select-c>
        </div>
        <div id="" class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <button id="buscar-btn" class="btn btn-default waves-effect waves-light" @click="submitInfo()" :class="[(desde === '' || ductoSelected === null || validation === false) ? 'disabled': '']">
            Buscar
          </button>
        </div>
      </div>

      <div id="range-wrapper" class="row">
        <div class="col-sm-3 col-sm-offset-1 col-xs-3">
          <p class="text-uppercase">rango de km</p>
        </div>
        <div class="col-sm-7 col-xs-9 color-slider">
          <input type="text" id="range" name="range" value="">
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7 col-xs-12">
          <button class="print_btn" @click="print()">Imprimir</button>
          <div class="panel-body-two" v-show="sitePdf">
            <pdf-div
              :site="sitePdf"
              :desde="desde"
              :hasta="hasta"
            ></pdf-div>
          </div>
        </div>
        <div class="col-md-5 col-xs-12">
          <div class="panel-body">
            <table class="table">
              <thead>
                <tr class="text-center">
                  <th>ID</th>
                  <th>Fecha</th>
                  <th>Lat</th>
                  <th>Lng</th>
                  <th>Km</th>
                  <th>Eventos</th>
                  <th>Descargar</th>
                </tr>
              </thead>
              <tbody v-show="objDucto" v-for="(r, key) in objDucto" :id="'alarm-' + key" :key="key">
                <tr>
                  <td class="nombre-alarma" colspan="7" style="height: 40px;"> {{ r.sites }} </td>
                </tr>
                <tr v-show="r && r.events && r.events.length > 0">
                  <td>{{ r.events[0].id || 'No Info'}} </td>
                  <td>{{ r.events[0].fecha || 'No Info' }} </td>
                  <td>{{ r.events[0].lat || 'No Info'}} </td>
                  <td>{{ r.events[0].lng || 'No Info'}} </td>
                  <td>{{ r.events[0].km || 'No Info'}} </td>
                  <td>{{ r.events.length || 'No Info'}} </td>
                  <td style="padding-left: 0; text-align:center;" v-show="serached">
                    <i @click="passName(objDucto[key])" class="material-icons prefix file_download" data-toggle="modal" data-target="#comentarioModal">file_download</i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
    <button id="loading-btn-chart2" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"> Iniciar sesión</button>
    <modal :name="modalName" cclass="transparent">
      <loading-modal :info="info"></loading-modal>
    </modal>
  </div>
</template>

<script>
let Modal = () => import('reusable/Modal')
let LoadingModal = () => import('components/Modals/LoginModal')
import SelectC from 'reusable/Select'
import datePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import PdfDiv from 'components/Historico/PdfDiv'
import toastr from 'toastr'

export default {
  data() {
    return {
       modalName: 'loading-modal',
        info: {
          modalName: this.modalName
        },
      serached: false,
      data: null,
      sitePdf: null,
      kmFrom: 0,
      kmTo: 10000,
      objDucto: {},
      desde: '',
      hasta: '',
      ductos: [],
      ducto: null,
      content: null,
      currDucto: '',
      desdeText: '',
      hastaText: '',
      ductoSelected: null,
      validation: false,
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde,
    }
  },
  methods: {
    loading() {
      document.querySelector('#loading-btn-chart2').click()
    },
    imgUrl(url) {
      return require(`${url}`)
    },
    print() {
      var content = document.querySelector('.panel-body-two').innerHTML
      var mywindow = window.open('', 'Print', 'height=600,width=800')

      mywindow.document.write('<html><head><title>Print</title>')
      mywindow.document.write('</head><body>')
    //  mywindow.document.write(content)
   //   mywindow.document.write('</body>')
      mywindow.document.write('<style>')
      mywindow.document.write(`
        #pdf {
          width: 100%;
        }
          #row {
            padding: 25px;
          }
          img.logo{
            width: 200px;
          }

          img.logo_pem{
            float:right;
          }
          hr {
            color: var(--btn-default);
          }
          h4 {
            text-align: center;
            text-transform: uppercase;
            color: var(--btn-default);
          }
          .pdf__info {
            margin: 0 auto;
            display: block;
          }
          .pdf__titles {
            color: var(--btn-default);
          }
      
       .mydiv{
          background-color:#fff;
          font-family: 'Roboto', sans-serif;
          }
          .mydiv div#pdf{
            max-height:200px;
            height:200px;
          }
          .mydiv div#img_map{
            width:70%;
            margin:auto;
          }
          .mydiv div#linechart{
            display:none;
          }
          .mydiv img#leak{
              display:inline-block;
              width:115px;
            }
          .mydiv img#pem{
              padding-left: 400px;
              display:inline-block;
              width:115px;
            }
          .mydiv h4#h41{
              font-size:30px;
              font-weight:400;
              text-transform: uppercase;
              padding:0;
              margin-top:10px;
              margin-bottom:10px;
            }
          .mydiv hr#hr1{
              	background-color: #fff;
	              border-top: 2px solid var(--btn-default);
            }
          .mydiv span#titles{
            color: var(--btn-default);
            text-transform: uppercase;
            margin-left:4px;
          }
          .mydiv div#tablecontainer{
            height:440px;
          }
          .mydiv table#tableholder{
            height: 50%;
            width:100%;
            margin:0;
          }
          .mydiv thead#header{
             width:100%;
             padding:2px;
             background-color:var(--btn-default);
          }
           .mydiv tr#trh{
             width:100%;
             padding:2px;
             background-color:var(--btn-default);
          }
          .mydiv th#thh{
            font-size:12px;
            align:left;
             font-weight:400;
             padding:5px;
             border: 1.5px solid var(--btn-default);
          }
          .mydiv td#tdc{
            font-size:8px;
             text-align:center;
             padding:2px;
             border: 1px solid #777777;
          }
        
      `)
     mywindow.document.write('</style>')
     // mywindow.document.write('</head><body>')
       mywindow.document.write('<div class="mydiv">' + content + '</div>')
      mywindow.document.write('</body>')
      mywindow.document.write('</html>')
      mywindow.document.close()
      mywindow.focus()
      setTimeout(function() {
            mywindow.print()
            mywindow.close()
        }, 100)
        return true
    },
    validate(e, d) {
      this[d] = e
      let max = this.hasta
      let min = this.desde
      if(max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor'
        this.hastaText = 'Este valor debe ser mayor'
        this.validation = false
      } else {
        this.desdeText = ''
        this.hastaText = ''
        this.validation = true
      }
    },
    changeSelected(){
      this.ductoSelected = document.querySelector('#ducto').value
    },
    formatDate() {
      let date = new Date().toLocaleString('es-US', {
        hour12: false
      }).split(' ')

      let time = date[1]
      let mdy = date[0].split('/')
      let month = parseInt(mdy[0])
      let day = parseInt(mdy[1])
      let year = parseInt(mdy[2])
      return `${year}-${day}-${month} ${time}`
    },
    submitInfo() {
      this.loading()
      this.serached = true
      if(!this.hasta) {
        this.hasta = this.formatDate()
      }

     if(this.desde && this.ductoSelected && this.validation === true) {
        this.$store.dispatch('LOAD_HISTORICO', {
          desde: this.desde,
          hasta: this.hasta,
          ducto: document.querySelector('#ducto').value,
          kmFrom: this.kmFrom,
          kmTo: this.kmTo
        }).then((resp) => {
          this.loading()
          if(resp.data.length === 0) {
            toastr.error('No se encontró información')
            return
          }
          this.data = resp.data
          this.fillTable()
        }).catch(err => {
          toastr.error('No se encontró información')
          console.log('Error', err)
        })
      } else {
        this.loading()
      }
    },
    fillTable() {
      this.objDucto = {}
      this.data.forEach(d => {
        this.ducto = d.section_1_name
        let leakKey = `${d.site_1_id}${d.site_2_id}`
        if(!this.objDucto[leakKey]) {
          this.objDucto[leakKey] = {}
          this.objDucto[leakKey].section = d.section_1_name
          this.objDucto[leakKey].sectionId = d.section_1_id
          this.objDucto[leakKey].sites = `${d.site_1_name} - ${d.site_2_name}`
          this.objDucto[leakKey].sitesIds = `${d.site_1_id},${d.site_2_id}`
          this.objDucto[leakKey].events = []
        }
        this.objDucto[leakKey].events.push({
          fecha: d.detection_timestamp,
          lat: d.lat,
          lng: d.lon,
          km: d.km,
          id: d.id_leak,
          type: d.type
          // site1: d.site_1_name,
          // site2: d.site_2_name,
          // city1: d.city_1_name,
          // city2: d.city_2_name,
          // siteid1: d.site_1_id,
          // siteid2: d.site_2_id
        })
      })
    },
    passName(r) {
      let markers = []
      let center = { lat: 0, lng: 0 }
      r.events.forEach(alarm => {
        markers.push(`markers=color:green%7C${alarm.lat},${alarm.lng}`)
        center.lat += alarm.lat
        center.lng += alarm.lng
      })
      center.lat /= r.events.length
      center.lng /= r.events.length
      r.map = `https://maps.googleapis.com/maps/api/staticmap?center=${center.lat},${center.lng}&zoom=10&size=800x400&${markers.join('&')}&key=AIzaSyAA-A7plJZRYMqQp06YF7c-WL6nFU0YZnY`
      this.sitePdf = r
    }
  },
  components: {
    SelectC,
    datePicker,
    PdfDiv,
    Modal,
    LoadingModal
  },
  mounted() {
    document.querySelector('#ducto').addEventListener('change', (e) => {
      this.kmFrom = $('#range').data().from
      this.kmTo = $('#range').data().to
    })

    this.$store.dispatch('LOAD_OPS')
    .then(resp => {
      this.ductos = this.$store.getters.GET_OP({
        filteredBy: 'section_name'
      })
    })
    .catch(err => {
      console.log('Error', err)
    })

    $('#range').ionRangeSlider({
      min: 0,
      max: 10000,
      from: 0,
      to: 10000,
      type: 'double',
      prefix: 'KM ',
      grid: true,
      grid_num: 2,
      onChange: () => {
        this.kmFrom = $('#range').data().from
        this.kmTo = $('#range').data().to
        let ev = new Event('change')
        document.querySelector('#ducto').dispatchEvent(ev)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~varmix";

#pdf {
}

.row {
  margin: 0;
  padding: 0;
}

.col-md-6,
.col-xs-12 {
  padding: 0px !important;
}

.container-fluid {
  background-color: white;
  width: 100%;
  padding: 0;
  margin: 0;
}

table,
.panel-body {
  overflow: scroll;
  height: 65vh; // width: 50vw;
  padding: 0px;
  margin: 0;
  .info {
    td {
      background-color: $bg;
    }
  }
  th {
    text-align: left;
    padding-left: 25px;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  td {
    text-align: left;
    padding-left: 25px;
    i {
      color: $inactive;
      cursor: pointer;
      &:hover {
        color: $amarilloC;
      }
    }
  }
  .nombre-alarma {
    background-color: $amarilloC;
    color: white;
  }
  .panel-body {
    padding: 0;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}

.panel-body-two {
  overflow: scroll;
  height: 65vh; // width: 50vw;
  padding: 0px 0;
  margin: 0;
  .info {
    td {
      background-color: $bg;
    }
  }
  th {
    text-align: left;
    padding-left: 25px;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  td {
    text-align: left;
    padding-left: 25px;
    i {
      color: $inactive;
      cursor: pointer;
      &:hover {
        color: $amarilloC;
      }
    }
  }
  .nombre-alarma {
    background-color: $amarilloC;
    color: white;
  }
  .panel-body {
    padding: 0;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}

.btn-default {
  background: $amarilloO;
  &:hover,
  &:focus,
  &:active {
    background: $amarilloC !important;
  }
}

#reportes-page {
  padding-top: 70px;
  background-color: $bg;
  height:100vh;
  #formulario-top {
    height: 30vh;
    @include celphone {
      height: 45vh;
    }
  }

  #range-wrapper {
    margin: 50px auto;
  }
}

// range
.color-2 .irs-bar,
.color-2 .irs-bar-edge {
  background: red;
}

.error {
  border: 2px solid red !important;
}

.print_btn{
  width:100%;
  background-color:$amarilloC;
  padding:8px;
  font-weight:500;
  color:white;
}
.print_btn:hover{
    background-color:$amarilloL;

}

.print_btn:active{
    background-color:gray;
    color:white;
}
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// Reportes.vue?22e4271c